export const capitalize = s => {
    if (typeof s !== 'string') return '';
    const wordArray = s.split(' ');
    var finalString = '';
    wordArray.forEach(word => {
        finalString = finalString + word.charAt(0).toUpperCase() + word.slice(1).toLowerCase() + ' ';
    });
    finalString = finalString.trim();
    return finalString;
};

export const shortName = (team, maxLength = 12) => {
    if (team.mascot) {
        return team.mascot;
    }
    if (team.displayName) {
        return shortString(team.displayName, maxLength);
    }
    if (team.teamName.length < maxLength) {
        return team.teamName;
    }
    let result = team.shortName && team.shortName.length < team.teamName.length ? team.shortName : team.teamName;
    return shortString(result, maxLength);
};

export const shortString = (string, maxLength = 12) => {
    var shortString = string;
    if (string.length > maxLength) {
        shortString = string.substring(0, maxLength - 3) + '...';
    }
    return shortString;
};

export const formatInitialLastName = (firstName, lastName) => {
    if (!firstName || !lastName) return '';
    return `${firstName.charAt(0)}. ${lastName}`;
};
